import { Interpolation } from '@emotion/css'

import { SmallOrLarge } from 'src/app/types'

const fontSizes = {
  small: 18,
  large: 25,
}

export default {
  title: (color: string, size: SmallOrLarge): Interpolation => ({
    fontSize: fontSizes[size],
    textTransform: 'uppercase',
    color, // TODO: Pull from theme
    fontWeight: 'bold',
    lineHeight: '32px',
    marginRight: 8,
    display: 'inline-block',
  }),
}
